import { apiWrapper } from '../helper/api-wrapper';

export const getProfile = async () => {
  try {
    const response = await apiWrapper.get('merchants/session/profile');

    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadBanner = async (data) => {
  try {
    const response = await apiWrapper.multipartPatch(
      'merchants/session/update_banner_v4',
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadProfilePhoto = async (data) => {
  try {
    const response = await apiWrapper.multipartPatch(
      'merchants/session/update_logo_v4',
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProfile = async (data, onProgress) => {
  try {
    const response = await apiWrapper.multipartPatch(
      'merchants/session/update_v4',
      data,
      onProgress
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateVendorProfile = async (data) => {
  try {
    const response = await apiWrapper.patch('merchants/session/update', data);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getBenefits = async () => {
  try {
    const response = await apiWrapper.get(
      'merchants/session/profile-cp-benefit'
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSettingProfile = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/session/update_setting`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUserPassword = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/session/update/password`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
